import { Controller } from '@hotwired/stimulus'

// Drives the live create-form preview. On template/event change it points the
// preview turbo-frame at GET /exhibitor/shared_reports/preview (debounced) and
// shows an "Updating preview…" state that also clears any stale preview. Auto-
// loads for ALL templates (user decision 2026-06-04 — WYSIWYG; the heavy-template
// opt-in gate was removed). Preview == recipient view by construction (same
// builder + _report_body). The GET frame src keeps it read-only/no-persistence.
export default class extends Controller {
  static targets = ['template', 'event', 'frame']
  static values = { url: { type: String, default: '/exhibitor/shared_reports/preview' } }

  connect() { this._timer = null }
  disconnect() { clearTimeout(this._timer) }

  templateChanged() { this.refresh() }

  refresh() {
    clearTimeout(this._timer)
    this._timer = setTimeout(() => this._load(), 350)
  }

  _load() {
    if (!this.hasFrameTarget) return
    if (!this.templateTarget.value) return // no template chosen yet
    // Clear stale content + show loading immediately; Turbo replaces this when
    // the frame response arrives.
    this.frameTarget.innerHTML = '<p class="text-muted">Updating preview…</p>'
    const params = new URLSearchParams()
    params.set('shared_report[report_template_id]', this.templateTarget.value || '')
    if (this.hasEventTarget) params.set('shared_report[event_exhibitor_id]', this.eventTarget.value || '')
    this.frameTarget.setAttribute('src', `${this.urlValue}?${params.toString()}`)
  }
}
